import { FunctionComponent, SVGProps } from 'react'

import { Box, Button } from '@material-ui/core'

import Link from '~/components/shared/Link'
import Text, { Title } from '~/components/shared/Text'

import Paths from '~/utils/paths'

import OnlyBoatsLogo from '~/assets/images/only-boats-logo.svg?sprite'
import OnlyVansLogo from '~/assets/images/only-vans-logo.svg?sprite'

import { getEntityByBrand } from '~/brands'

const titleText = getEntityByBrand<string>({
  rv: 'Thank you for your TradeRVs Listing',
  boat: 'Thank you for your Trade-A-Boat Listing'
})

interface DealerConfigType {
  title: string
  platform: string
  questionsEmail: string
  contactTeamEmail: string
  link: string
  linkText: string
  logo: FunctionComponent<SVGProps<SVGAElement>>
}

const dealerConfig = getEntityByBrand<DealerConfigType>({
  rv: {
    title: 'Thank you for becoming a Trade RV dealer.',
    platform: 'Trade RV',
    questionsEmail: 'hello@tradervs.com.au',
    contactTeamEmail: 'jerry.h@onlyvans.com.au',
    link:
      'https://www.onlyvans.com.au/sell-my-van?utm_source=trv&utm_medium=website&utm_campaign=cross_promotion',
    linkText: 'OnlyVans.com.au',
    logo: <OnlyVansLogo width={300} height={100} />
  },
  boat: {
    title: 'Thank you for becoming a Trade A Boat dealer',
    platform: 'Trade A Boat',
    questionsEmail: 'hello@tradeaboat.com.au',
    contactTeamEmail: 'jarred.l@onlyboats.com.au',
    link:
      'https://www.onlyboats.com.au/sell-my-boat?utm_source=tab&utm_medium=website&utm_campaign=cross_promotion',
    linkText: 'OnlyBoats.com.au',
    logo: <OnlyBoatsLogo width={200} height={100} />
  }
})

interface AdListingConfig {
  title: string
  partner: string
  link: string
  price: string
  discountCode: string
  logo: FunctionComponent<SVGProps<SVGAElement>>
}

const adListingConfig = getEntityByBrand<AdListingConfig>({
  rv: {
    title: 'Thank you for listing on Trade RV’s',
    partner: 'OnlyVans.com.au',
    link:
      'https://www.onlyvans.com.au/sell-my-van?utm_source=trv&utm_medium=website&utm_campaign=cross_promotion',
    price: '$19.95',
    discountCode: 'TRADERVS',
    logo: <OnlyVansLogo width={300} height={100} />
  },
  boat: {
    title: 'Thank you for listing on Trade-A-Boat',
    partner: 'OnlyBoats.com.au',
    link:
      'https://www.onlyboats.com.au/sell-my-boat?utm_source=tab&utm_medium=website&utm_campaign=cross_promotion',
    price: '$9.95',
    discountCode: 'TRADEABOAT',
    logo: <OnlyBoatsLogo width={200} height={100} />
  }
})

export const CONGRATULATION_TITLE = {
  dealer: (
    <>
      {dealerConfig.title}

      <Text fontSize={18} mt={1}>
        Your dealer profile will be automatically activated after processing the
        payment.
      </Text>

      <Text fontSize={18}>
        Should you have any questions, please email us at{' '}
        <Link
          href={`mailto:${dealerConfig.questionsEmail}`}
          target="_blank"
          rel="noreferrer"
        >
          {dealerConfig.questionsEmail}
        </Link>
      </Text>

      <Text fontSize={20} mt={2}>
        We have recently partnered with{' '}
        <Text component="span" fontWeight={700}>
          {dealerConfig.linkText}
        </Text>
      </Text>

      <Text fontSize={18} mt={2}>
        By becoming a {dealerConfig.platform} dealer, you now have access to an
        exclusive dual subscription offering. The team from{' '}
        {dealerConfig.linkText} will be in contact with you very soon. If you
        wish to contact the team now, please email{' '}
        <Link
          href={`mailto:${dealerConfig.contactTeamEmail}`}
          target="_blank"
          rel="noreferrer"
        >
          {dealerConfig.contactTeamEmail}
        </Link>
      </Text>

      <Link href={dealerConfig.link} target="_blank" rel="noreferrer">
        {dealerConfig.logo}
      </Link>
    </>
  ),
  business: `Thank you for registering a business.\nYour business profile will be automatically activated after passing the payment.`,
  ad: (
    <>
      {adListingConfig.title}

      <Box maxWidth={680} margin="0 auto" my={2}>
        <Text textAlign="center">
          Your listing has been sent for review by our team. If we require any
          further information to publish your listing, we may call or email you.
          Your listing should be live within one working day, you will be
          notified once its live.
        </Text>

        <Title fontSize={20} mt={2} fontWeight={500}>
          Special offer!
        </Title>

        <Text textAlign="center" mt={2}>
          Would you like to maximise your sale potential? We have partnered with{' '}
          <Text component="span" fontWeight={700}>
            {adListingConfig.partner}
          </Text>
          . List your asset right now for {adListingConfig.price}, simply click
          the link below and use discount code {adListingConfig.discountCode}{' '}
          for your exclusive discount.
        </Text>

        <Link href={dealerConfig.link} target="_blank" rel="noreferrer">
          {dealerConfig.logo}
        </Link>
      </Box>
    </>
  ),
  promotion: (
    <>
      {titleText}
      <Box maxWidth={520} margin="0 auto" my={2}>
        <Text textAlign="center">Promotion(s) will be activated soon</Text>
      </Box>

      <Link href={Paths.account.dashboard}>
        <Button
          variant="contained"
          color="primary"
          style={{ minWidth: 173, height: 50 }}
        >
          My Account
        </Button>
      </Link>
    </>
  )
}

export const ENTITIES = {
  ad: 'ad',
  business: 'business',
  dealer: 'dealer',
  promotion: 'promotion'
}
